import React from "react";
import { useNavigate } from 'react-router-dom';
import "./Stone.css";
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const Contact = () => {
  const navigate = useNavigate();

  const goToQuoteForm = () => {
    sessionStorage.setItem("scrollToQuote", "true");
    navigate("/");
  };

  return (
    <div className="stone-page">
      <Header />
      {/* Hero Section */}
      <section className="stone-hero">
        <h1>Contact HRZ Landscaping</h1>
        <p>
          We’re here to help. Whether you have a question, need a quote, or want to schedule a consultation, we’d love to hear from you!
        </p>
      </section>

          {/* Contact Info Cards */}
      <section
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "40px 20px",
          gap: "24px",
          flexWrap: "wrap",
        }}
      >
        {[ // use mapping to keep it DRY
          {
            title: "📧 Email",
            value: "hrzlandscapinge@gmail.com",
            href: "mailto:hrzlandscapinge@gmail.com",
          },
          {
            title: "📞 Phone",
            value: "(415) 235-2545",
            href: "tel:4152352545",
          },
        ].map((item, i) => (
          <div
            key={i}
            className="stone-card"
            style={{
              textAlign: "center",
              flex: "1 1 250px",
              maxWidth: "300px",
              minWidth: "250px",
            }}
          >
            <h3>{item.title}</h3>
            <p>
              <a
                href={item.href}
                style={{ color: "#2c2c2c", textDecoration: "none" }}
              >
                {item.value}
              </a>
            </p>
          </div>
        ))}
      </section>


      {/* CTA Section with Button */}
      <section className="stone-cta" style={{ paddingTop: "60px" }}>
        <p>
          Want to get started right away? Send us your project details and we’ll get back to you soon.
        </p>
        <button
          onClick={goToQuoteForm}
          style={{
            backgroundColor: "#2E7D32",
            color: "white",
            border: "none",
            padding: "12px 30px",
            fontSize: "1rem",
            borderRadius: "8px",
            cursor: "pointer"
          }}
        >
          Request an Estimate <span className="cta-arrow">→</span>
        </button>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
